import * as React from 'react';

import styles from './static-two-line-with-icon.module.css';

type Props = {
    title: string | React.ReactNode;
    subtitle: string | React.ReactNode;
    icon?: React.ComponentType<any> | React.ReactNode;
    isDisabled?: boolean;
    disabledSubtitleText?: string;
};

export function StaticTwoLineWithIcon(props: Props) {
    const Icon = props.icon && typeof props.icon === 'function' ? props.icon : undefined;
    const iconComponent = props.icon && typeof props.icon === 'object' ? props.icon : undefined;

    return (
        <div
            className={
                props.isDisabled ? styles['title-container--disabled'] : styles['title-container']
            }
        >
            <div className={styles.title}>{props.title}</div>
            {props.isDisabled && props.disabledSubtitleText ? (
                <i>{props.disabledSubtitleText}</i>
            ) : (
                <div className={styles['type-container']}>
                    {Icon || iconComponent ? (
                        <div className={styles.icon}>
                            {Icon ? <Icon size={14} /> : undefined}
                            {iconComponent ? iconComponent : undefined}
                        </div>
                    ) : undefined}
                    {props.subtitle ? props.subtitle : undefined}
                </div>
            )}
        </div>
    );
}
